import { BrowserModule, Meta, Title } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule, LOCALE_ID, APP_INITIALIZER  } from '@angular/core';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { DeviceDetectorModule } from 'ngx-device-detector';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NegociacionComunidadesComercioComponent } from './negociacion-comunidades-comercio/negociacion-comunidades-comercio.component';
import { RestriccionDeConveniosComponent } from './restriccion-de-convenios/restriccion-de-convenios.component';
import { ModificacionDatosComercialesComponent } from './modificacion-datos-comerciales/modificacion-datos-comerciales.component';
import { CorrecionPagoPorErrorComponent } from './correcion-pago-por-error/correcion-pago-por-error.component';
import { TrasladoMetroBolsaComponent } from './traslado-metro-bolsa/traslado-metro-bolsa.component';
import { NegociacionDeudaClientesResidencialesComponent } from './negociacion-deuda-clientes-residenciales/negociacion-deuda-clientes-residenciales.component';
import { SuscripcionBoletaElectronicaComponent } from './suscripcion-boleta-electronica/suscripcion-boleta-electronica.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BigBannerComponent } from './big-banner/big-banner.component';
import { EmergenciaComponent } from './emergencia/emergencia.component';
import { BoletaElectronicaComponent } from './boleta-electronica/boleta-electronica.component';

import { SlickCarouselModule } from 'ngx-slick-carousel';
//import { BotonComponent } from './components/boton/boton.component';
import { SolicitudRecibidaComponent } from './components/solicitud-recibida/solicitud-recibida.component';

import { HttpClientModule } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbDatepickerI18n } from "@ng-bootstrap/ng-bootstrap";
import { NgbDateCustomParserFormatter } from './shared/NgbDateCustomParserFormatter.service';

import {AutocompleteLibModule} from 'angular-ng-autocomplete';

import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';

import { NgxSpinnerModule } from "ngx-spinner";

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagaTuCuentaComponent } from './paga-tu-cuenta/paga-tu-cuenta.component';
import { DuplicadoBoletaComponent } from './duplicado-boleta/duplicado-boleta.component';
import { SuscripcionBoletaSatisfactoriaComponent } from './components/suscripcion-boleta-satisfactoria/suscripcion-boleta-satisfactoria.component';
import { BeneficioClientesVulnerablesCovid19Component } from './beneficio-clientes-vulnerables-covid19/beneficio-clientes-vulnerables-covid19.component';
import { SuscripcionBeneficioCovid19SatisfactoriaComponent } from './components/suscripcion-beneficio-covid19-satisfactoria/suscripcion-beneficio-covid19-satisfactoria.component';
import { BeneficioCovid19Component } from './beneficio-covid19/beneficio-covid19.component';
import { ConoceBoletaElectronicaComponent } from './conoce-tu-boleta/conoce-tu-boleta.component';
import { ConoceCentroAyudaComponent } from './conoce-centro-ayuda/conoce-centro-ayuda.component';
import { VentaReguladoresComponent } from './venta-reguladores/venta-reguladores.component';
import { AgendamientoHoraComponent } from './agendamiento-hora/agendamiento-hora.component';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ExitoAgendamientoComponent } from './agendamiento-hora/exito-agendamiento/exito-agendamiento.component';
import {NgxWebstorageModule} from 'ngx-webstorage';
import { AsistenteVirtualComponent } from './asistente-virtual/asistente-virtual.component';
import { CommonModule } from '@angular/common';
import { NegociacionComerciosComponent } from './negociacion-comercios/negociacion-comercios.component';
import { PagoDobleComponent } from './pago-doble/pago-doble.component';

import { ApiService } from './shared/api.service';
import { CambioNombreBoletaComponent } from './cambio-nombre-boleta/cambio-nombre-boleta.component';
import { ContactenosComponent } from './contactenos/contactenos.component';
import { TrackingComponent } from './tracking/tracking.component';
import { InfoCuentaComponent } from './info-cuenta/info-cuenta.component';
import { ChartModule } from 'angular2-chartjs';
import { ModalNumeroClientesComponent } from './modales/modal-numero-clientes/modal-numero-clientes.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalCallejeroNumeroClientesComponent } from './modales/modal-callejero-numero-clientes/modal-callejero-numero-clientes.component';
import { ClienteNumeroModalComponent } from './modales/cliente-numero-modal/cliente-numero-modal.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ConfirmDialogConsultaDuplicadaComponent } from './modales/confirm-dialog-consulta-duplicada/confirm-dialog-consulta-duplicada.component';
import { ModalPoliticaPrivacidadComponent } from './modales/modal-politica-privacidad/modal-politica-privacidad.component';
import { MatIconModule } from '@angular/material/icon';
import { ImagePopupComponent } from './image-popup/image-popup.component'; 


registerLocaleData(localeES, 'es');

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NegociacionComunidadesComercioComponent,
    RestriccionDeConveniosComponent,
    ModificacionDatosComercialesComponent,
    CorrecionPagoPorErrorComponent,
    TrasladoMetroBolsaComponent,
    HeaderComponent,
    FooterComponent,
    BigBannerComponent,
    EmergenciaComponent,
    BoletaElectronicaComponent,
    //BotonComponent,
    SolicitudRecibidaComponent,
    NegociacionDeudaClientesResidencialesComponent,
    SuscripcionBoletaElectronicaComponent,
    PagaTuCuentaComponent,
    DuplicadoBoletaComponent,
    SuscripcionBoletaSatisfactoriaComponent,
    BeneficioClientesVulnerablesCovid19Component,
    SuscripcionBeneficioCovid19SatisfactoriaComponent,
    BeneficioCovid19Component,
    ConoceBoletaElectronicaComponent,
    ConoceCentroAyudaComponent,
    AgendamientoHoraComponent,
    ExitoAgendamientoComponent,
    VentaReguladoresComponent,
    AsistenteVirtualComponent,
    NegociacionComerciosComponent,
    PagoDobleComponent,
    CambioNombreBoletaComponent,
    ContactenosComponent,
    TrackingComponent,
    InfoCuentaComponent,
    ModalNumeroClientesComponent,
    ModalCallejeroNumeroClientesComponent,
    ClienteNumeroModalComponent,
    ConfirmDialogConsultaDuplicadaComponent,
    ModalPoliticaPrivacidadComponent,
    ImagePopupComponent  

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    HttpClientModule,
    DeviceDetectorModule.forRoot(),
    NgbModule,
    CommonModule,

    AutocompleteLibModule,

    NgSelectModule,
    FormsModule,

    NgxSpinnerModule,
    BrowserAnimationsModule,
    CalendarModule,
    DropdownModule,
    NgxWebstorageModule.forRoot(),
    RecaptchaV3Module,
    ChartModule,
    MatDialogModule,
    MatIconModule,
    ClipboardModule

  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: Meta },
    { provide: Title },
    { provide: 'googleTagManagerId', useValue: 'GTM-KDPLG2TS'},
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LevOKUUAAAAAOSf3Z_kcLBTRPy12HLrMKf-16OC' },
    { provide: APP_INITIALIZER,
      useFactory: (apiService: ApiService) =>
        () => apiService.CargarConfiguracion(),
      deps: [ApiService],
      multi: true}
  ],
  bootstrap: [AppComponent],
  entryComponents: [ClienteNumeroModalComponent]

})
export class AppModule { }
